import { call, put, select } from 'redux-saga/effects';
import { getBrand } from 'ctm-app/client/store/selectors';
import { setTokens } from './utils/tokens';

const START_PAGE_PATH = '/car-insurance/journey/start';

const replaceWithStartPage = function* (browserHistory) {
    yield call(browserHistory.replace, START_PAGE_PATH);
};

/**
 * Validates and prepares a CTM proactive handover before existing prefill verification.
 * @param {Object} action - Contains the browser history used to recover invalid handovers.
 */
export const processProactiveHandover = function* ({ browserHistory }) {
    const brandCode = yield select(getBrand);
    const queryParams = new URLSearchParams(window.location.search);
    const anonymousId = queryParams.get('user_anonymous_id');
    const redbookCode = queryParams.get('redbook_code');
    const journeyId = queryParams.get('journey_id');
    const accessToken = queryParams.get('access_token');

    if (brandCode !== 'ctm' || !anonymousId || !redbookCode || !journeyId || !accessToken) {
        yield* replaceWithStartPage(browserHistory);
        return;
    }

    try {
        yield call([window.history, 'replaceState'], null, '', window.location.pathname);
        yield call(setTokens, { access_token: accessToken });
        sessionStorage.setItem('has_prefill_candidate', 'true');
        sessionStorage.setItem('user_anonymous_id', anonymousId);

        yield put({
            type: 'DO_PREFILL_VERIFY',
            payload: {
                requestPayload: { carRedbookCode: redbookCode },
                verifyParams: {
                    journey_origin: 'PROACTIVE_QUOTE',
                    journey_id: journeyId
                },
                nextPageName: 'start',
                replaceOnFailure: true
            }
        });
    } catch (error) {
        yield* replaceWithStartPage(browserHistory);
    }
};
